// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"3ae2d2da","297":"d03b8a4e","643":"d49c3279"}[chunkId] + ".js";
};